// Utilidad para darle formato a los precios
import numeral from 'numeral';

const formatPrice = price => {
    return numeral(price).format('0,0');
};

export default formatPrice;


// WEBPACK FOOTER //
// ./src/utils/formatPrice.js